import ProductDescription from './ProductDescription'

const OatsOatmealProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '005',
  IsBroadband: true,
  GrainSize: '16 ounces only',
  OatType: '',
  CookingType: '',
  OatVariety: '',
  otherType: '',
  otherVariety: '',
}

export default OatsOatmealProduct